import React, { useRef } from 'react'
import { PanResponder, Pressable, View } from 'react-native'

import { useDeviceInfo } from '~hooks'
import { noop } from '~utils'

type Props = {
  children: React.ReactNode
  onPress: () => void
}

export const PressableGesture = ({ children, onPress = noop }: Props) => {
  const maxGestureRef = useRef<number>(0)
  const { isWeb } = useDeviceInfo()
  const gestureHandler = PanResponder.create({
    onStartShouldSetPanResponder: () => true,
    onMoveShouldSetPanResponder: () => true,
    onPanResponderGrant: () => {
      maxGestureRef.current = 0
    },
    onPanResponderMove: (_, { dy, dx }) => {
      const x = Math.abs(dx || 0)
      const y = Math.abs(dy || 0)
      x > maxGestureRef.current && (maxGestureRef.current = x)
      y > maxGestureRef.current && (maxGestureRef.current = y)
    },

    onPanResponderRelease: () => {
      if (maxGestureRef.current < 10) {
        onPress()
      }
    },
  })

  return isWeb ? (
    <View {...gestureHandler.panHandlers}>{children}</View>
  ) : (
    <Pressable onPress={onPress}>{children}</Pressable>
  )
}
